import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColumns3"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.12109 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.8789 3.5V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconColumns3;
